import fetcher from 'api/fetcher';
import { AxiosError } from 'axios';
import { push } from 'connected-react-router';
import { MagritteNotificationName } from 'utils/constants/notification';

import generateTextFormSubmit from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_design/generate_text_form_submit';
import cpcQuickPublishFormSubmit, {
    PublicationType,
} from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_menu/cpc_quick/cpc_quick_publish_form_submit';

import { setScrollToAds, setShouldSendUXFBEvent } from 'store/autoReducers';
import { resetAiImageGeneration } from 'store/models/aiImageGeneration';
import { resetBannerTextGeneration } from 'store/models/bannerTextGeneration';
import {
    QuickCampaignErrorName,
    QuickCampaignFormData,
    QuickCampaignFormErrors,
    resetQuickCampaignBannerImages,
    resetQuickCampaignCroppedImages,
    setQuickCampaignFormErrors,
} from 'store/models/createQuickCampaign';
import { addMagritteNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

type StartQuickCampaignRequest = QuickCampaignFormData;

interface StartQuickCampaignResponse {
    campaignId: string;
}

export const startQuickCampaign = (setSaving: (isSaving: boolean) => void, dashboardRoute: string): AppThunkAction => {
    return (dispatch, getState) => {
        setSaving(true);

        const body = getState().createQuickCampaign.formData;
        const { bannerTextWasGenerated, bannerTextGenerationCount, bannerTextType } = getState().bannerTextGeneration;

        const { vacancyId, quickStartType, budget } = body;

        return fetcher
            .post<StartQuickCampaignRequest, StartQuickCampaignResponse>('/api/v1/campaigns/quick_start', body)
            .then((response: StartQuickCampaignResponse): void => {
                const { campaignId } = response;
                cpcQuickPublishFormSubmit({
                    vacancyId: Number(vacancyId),
                    publicationType: quickStartType as PublicationType,
                    budget: Number(budget),
                    bannerTextType,
                    triesCount: bannerTextGenerationCount,
                });

                if (bannerTextWasGenerated) {
                    generateTextFormSubmit({
                        vacancyId: String(vacancyId),
                        campaignId,
                        triesCount: String(bannerTextGenerationCount),
                    });
                }

                dispatch([
                    setScrollToAds(true),
                    addMagritteNotification(MagritteNotificationName.CreateQuickCampaignSaveSuccess),
                ]);
                dispatch(setShouldSendUXFBEvent(true));

                dispatch(push(dashboardRoute));
                dispatch([
                    resetAiImageGeneration(null),
                    resetQuickCampaignCroppedImages(null),
                    resetQuickCampaignBannerImages(null),
                    resetBannerTextGeneration(),
                ]);
            })
            .catch((error: AxiosError<QuickCampaignFormErrors>) => {
                const errors = error?.response?.data;
                if (error?.response?.status === 400 && errors) {
                    const regionIdError = errors[QuickCampaignErrorName.RegionId];
                    if (regionIdError) {
                        dispatch(addMagritteNotification(regionIdError));
                    } else {
                        dispatch(setQuickCampaignFormErrors(errors));
                        dispatch(addMagritteNotification(MagritteNotificationName.CreateQuickCampaignValidationError));
                    }
                } else {
                    dispatch(
                        addMagritteNotification(MagritteNotificationName.CreateQuickCampaignSomethingWentWrongError)
                    );
                }
                cpcQuickPublishFormSubmit({
                    vacancyId: Number(vacancyId),
                    publicationType: quickStartType as PublicationType,
                    budget: Number(budget),
                    bannerTextType,
                    triesCount: bannerTextGenerationCount,
                    errors: JSON.stringify(errors),
                });
                setSaving(false);
            });
    };
};
